import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'AgencyMemberEdit',
  data: function data() {
    return {
      props: {
        multiple: false
      },
      title: '',
      agencyMemberRoleTypeEnums: [],
      agencyMemberSettlementItemEnums: [],
      agencyMemberStatsEnums: [],
      agentAettlementProportions: [],
      totalAgenReward: [],
      isEdis: false,
      isCitys: false,
      citys: [],
      form: {
        agencyId: null,
        userName: '',
        passWord: '',
        name: '',
        idCard: '',
        roleType: 1,
        settlementItem: null,
        settlementProportion: null,
        recommenderId: null,
        recommenderProportion: null,
        stats: null,
        createTime: null,
        createUser: null,
        selectCitys: [],
        settlementItems: [],
        recommenderUserName: '',
        corporateName: null,
        bankOfDeposit: null,
        bankAccount: null,
        phone: null,
        profitAssessmentValue: null,
        openBankProvince: null,
        openBankCity: null,
        openBankAreCode: null,
        generalAgencyUsername: null,
        totalAgentReward: '70',
        superAdminUser: null,
        channelSettlementAccount: null,
        openUserSettlement: null,
        openMatchmakerSettlement: null
      },
      rules: {
        agencyId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        userName: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        passWord: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入用户姓名',
          trigger: 'blur'
        }],
        idCard: [{
          required: true,
          message: '请输入身份证',
          trigger: 'blur'
        }],
        roleType: [{
          required: true,
          message: '请选择代理类型',
          trigger: 'blur'
        }],
        settlementItems: [{
          required: true,
          message: '请输入结算项目',
          trigger: 'blur'
        }],
        settlementProportion: [{
          required: true,
          message: '请输入结算比例',
          trigger: 'blur'
        }],
        recommenderUserName: [{
          required: true,
          message: '推荐人账号不能为空',
          trigger: 'blur'
        }],
        recommenderProportion: [{
          required: true,
          message: '请输入平台奖励比例',
          trigger: 'blur'
        }],
        stats: [{
          required: true,
          message: '请输入状态 0 正常 1注销 2 冻结',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        selectCitys: [{
          required: true,
          message: '请选择开通区域',
          trigger: 'blur'
        }],
        // corporateName: [
        //   { required: true, message: '企业名称不能为空', trigger: 'blur' }
        // ],
        // bankOfDeposit: [
        //   { required: true, message: '开户行不能为空', trigger: 'blur' }
        // ],
        // bankAccount: [
        //   { required: true, message: '银行账号不能为空', trigger: 'blur' }
        // ],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        profitAssessmentValue: [{
          required: true,
          message: '请输入利润考核值',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    superAdminUserChange: function superAdminUserChange(e) {
      if (e != null && e !== '') {
        this.form.totalAgentReward = '20';
      } else {
        this.form.totalAgentReward = '70';
      }
    },
    cancheUserName: function cancheUserName(e) {
      this.resultMemberInfoApi(e);
      // 代理账号输入以后，结算账号自动默认显示为代理账号
      this.form.superAdminUser = e;
    },
    resultMemberInfoApi: function resultMemberInfoApi(e) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, res, obj, citys;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = {
                userName: e,
                type: 2
              };
              _context.n = 1;
              return api.resultMemberInfo(data);
            case 1:
              res = _context.v;
              if (res.body.sts) {
                obj = res.body;
                citys = [];
                if (obj.member !== null && obj.member !== undefined) {
                  _this.form.name = obj.member.name;
                  _this.form.idCard = obj.member.idNo;
                  _this.form.phone = obj.member.phone;
                  citys.push(obj.member.province + '');
                  citys.push(obj.member.city + '');
                  citys.push(obj.member.area + '');
                }
                if (obj.agencyMember !== null && obj.agencyMember !== undefined) {
                  _this.form.name = obj.agencyMember.name;
                  _this.form.idCard = obj.agencyMember.idCard;
                  _this.form.phone = obj.agencyMember.userName;
                  citys.push(obj.agencyMember.province + '');
                  citys.push(obj.agencyMember.city + '');
                  citys.push(obj.agencyMember.area + '');
                }
                if (obj.agencyPromotion !== null && obj.agencyPromotion !== undefined) {
                  _this.form.name = obj.agencyPromotion.name;
                  _this.form.idCard = obj.agencyPromotion.idCard;
                  _this.form.phone = obj.agencyPromotion.userName;
                  citys = obj.agencyPromotion.citys;
                }
                _this.form.selectCitys = [citys];
                _this.form.settlementItems = [_this.agencyMemberSettlementItemEnums[0].values];
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    roleTypeChane: function roleTypeChane(value) {
      if (value === 1) {
        this.isCitys = false;
      } else {
        this.isCitys = true;
      }
    },
    checkProp: function checkProp() {
      if (!this.isEdis) {
        return 'passWord';
      }
      return '';
    },
    getTotalAgentRewardData: function getTotalAgentRewardData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'total_agent_reward'
              });
            case 1:
              res = _context2.v;
              _this2.totalAgenReward = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAgentAettlementProportions: function getAgentAettlementProportions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var thiz;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              thiz = _this3;
              _this3.enums.getAgentSettlementProportion(function (result) {
                thiz.agentAettlementProportions = result.body;
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAgencyMemberRoleTypeEnums: function getAgencyMemberRoleTypeEnums() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'agency_role_type'
              });
            case 1:
              res = _context4.v;
              _this4.agencyMemberRoleTypeEnums = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getAgencyMemberSettlementItemEnums: function getAgencyMemberSettlementItemEnums() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'agency_settlement_items'
              });
            case 1:
              res = _context5.v;
              _this5.agencyMemberSettlementItemEnums = res.body;
              // 结算项目输入框已隐藏：添加时默认取下拉第 1 项，编辑时保持原值
              if (!_this5.isEdis && _this5.agencyMemberSettlementItemEnums.length > 0) {
                _this5.form.settlementItems = [_this5.agencyMemberSettlementItemEnums[0].values];
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    initCitys: function initCitys() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context6.v;
              _this6.citys = res.body;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    initEunmData: function initEunmData() {
      this.agencyMemberRoleTypeEnums = [];
      this.agencyMemberSettlementItemEnums = [];
      this.agencyMemberStatsEnums = [];
      this.citys = [];
      this.getAgencyMemberRoleTypeEnums();
      this.getAgencyMemberSettlementItemEnums();
      this.initCitys();
      this.getAgentAettlementProportions();
      this.getTotalAgentRewardData();
    },
    getEnumList: function getEnumList(name) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                name: name
              };
              _context7.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context7.v;
              _this7.enumList = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initEunmData();
      this.form.agencyId = null;
      this.form.userName = null;
      this.form.passWord = '123456';
      this.form.name = null;
      this.form.idCard = null;
      this.form.roleType = 1;
      this.form.settlementItem = null;
      this.form.settlementProportion = null;
      this.form.recommenderId = null;
      this.form.recommenderProportion = null;
      this.form.stats = null;
      this.form.createTime = null;
      this.form.createUser = null;
      this.form.selectCitys = [];
      this.form.settlementItems = [];
      this.form.recommenderUserName = '';
      this.form.corporateName = null;
      this.form.bankOfDeposit = null;
      this.form.bankAccount = null;
      this.form.phone = null;
      this.form.profitAssessmentValue = null;
      this.form.openBankProvince = null;
      this.form.openBankCity = null;
      this.form.openBankAreCode = null;
      this.form.generalAgencyUsername = null;
      this.isEdis = false;
      this.form.totalAgentReward = '70';
      this.form.superAdminUser = null;
      this.form.channelSettlementAccount = null;
      this.form.openUserSettlement = null;
      this.form.openMatchmakerSettlement = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initEunmData();
      this.form.agencyId = data.agencyId + '';
      this.form.userName = data.userName;
      this.form.name = data.name;
      this.form.passWord = null;
      this.form.idCard = data.idCard;
      this.form.roleType = data.roleType + '';
      this.form.settlementItem = data.settlementItem + '';
      this.form.settlementProportion = data.settlementProportion + '';
      this.form.recommenderId = data.recommenderId + '';
      this.form.totalAgentReward = data.totalAgentReward + '';
      if (data.recommenderProportion !== 0) {
        this.form.recommenderProportion = data.recommenderProportion + '';
      } else {
        this.form.recommenderProportion = null;
      }
      this.form.stats = data.stats + '';
      this.form.createTime = data.createTime + '';
      this.form.createUser = data.createUser + '';
      if (data.roleType === 1) {
        this.isCitys = true;
      } else {
        this.isCitys = false;
      }
      if (data.selectCitys.length > 0) {
        var cityData = data.selectCitys[0];
        var citys = [];
        for (var i = 0; i < cityData.length; i++) {
          var item = cityData[i];
          citys.push(item + '');
        }
        this.form.selectCitys = citys;
      } else {
        this.form.selectCitys = [];
      }
      this.form.settlementItems = JSON.parse(data.settlementItem);
      this.form.recommenderUserName = data.recommenderAgencyMember !== null ? data.recommenderAgencyMember.userName : null;
      this.form.corporateName = data.corporateName;
      this.form.bankOfDeposit = data.bankOfDeposit;
      this.form.bankAccount = data.bankAccount;
      this.form.phone = data.phone;
      this.form.profitAssessmentValue = data.profitAssessmentValue;
      this.form.openBankProvince = data.openBankProvince;
      this.form.openBankCity = data.openBankCity;
      this.form.openBankAreCode = data.openBankAreCode;
      this.form.generalAgencyUsername = data.generalAgencyUsername;
      this.form.superAdminUser = data.superAdminUser !== null && data.superAdminUser !== '' ? data.superAdminUser : data.userName;
      this.form.channelSettlementAccount = data.channelSettlementAccount;
      this.form.openUserSettlement = data.openUserSettlement;
      this.form.openMatchmakerSettlement = data.openMatchmakerSettlement;
      this.isEdis = true;
    },
    updateApi: function updateApi() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return api.UPDATE_AGENCYMEMBER(_this8.form);
            case 1:
              _this8.$emit('initTableData');
              _this8.$message.success('操作成功');
              _this8.handleClose();
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    saveApi: function saveApi() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return api.SAVE_AGENCYMEMBER(_this9.form);
            case 1:
              _this9.$emit('initTableData');
              _this9.$message.success('操作成功');
              _this9.handleClose();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    save: function save() {
      var _this0 = this;
      // 空输入转为 null，避免后端 BigDecimal 字段解析空字符串报错
      this.form.openUserSettlement = this.form.openUserSettlement === '' ? null : this.form.openUserSettlement;
      this.form.openMatchmakerSettlement = this.form.openMatchmakerSettlement === '' ? null : this.form.openMatchmakerSettlement;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this0.form.selectCitys = [_this0.form.selectCitys];
          _this0.form.settlementItem = JSON.stringify(_this0.form.settlementItems);
          if (_this0.form.agencyId != null) {
            _this0.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this0.updateApi();
            }).catch(function () {
              _this0.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this0.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};